import service from '@/utils/services'
import storage from '@/utils/localStorage'
import utils from '@/utils/utils'

const isMobile = utils.isMobile()
const isIPhone = utils.isIPhone()
const systemBrowser = utils.getSystemBrowser()
const systemOs = utils.getSystemInfo()
const source = utils.getQueryParam('utm_source')
const position = utils.getQueryParam('ad_position')

const state = {
  gameNewId: 24,
  homeNewId: 25,
  homeBannerPid: 18,
  mHomeBannerPid: 21,
  homeGameimgPid: 19,
  mHomeGameimgPid: 20,
  isMobile: isMobile,
  isIPhone: isIPhone,
  staticUrl: window.staticUrl,
  utmSource: source,
  adPosition: position,
  basicData: {
    address: '',
    company: '',
    copyright: '',
    description: '',
    keywords: '',
    record_number: '',
    title: '',
  },
  footLinks: [
    { id: 1, name: '隐私政策', url: '/informationDetail?id=21' },
    { id: 2, name: '服务条款', url: '/informationDetail?id=22' },
    { id: 3, name: '关于我们', url: '/informationDetail?id=23' },
    { id: 4, name: '联系我们', url: 'mailto:xzdzm_cs@zhuziplay.com?subject=contact' }
  ],
  gameUserInfo: {
    channel_user_id: '',
    username: '',
    realname: '',
    mobile: '',
    open_id: '',
    token: '',
    user_id: '',
    zhuziToken: ''
  },
  downloadUrl: {
    iosUrl: 'https://apps.apple.com/cn/app/id6446186200',
    androidUrl: 'https://bamboo.zhuziplay.com/onelink/android/cn_zhuzi',
    leidianUrl: 'https://res.ldmnq.com/game_version/apk/XpsaJ5-1686275284847.apk',
    mumuUrl: 'https://a11.gdl.netease.com/MuMuInstaller_3.1.4.0_yxxzdzm_zh-Hans_1687144078.exe',
    taptapUrl: 'https://www.taptap.cn/app/244155?utm_medium=rep&utm_source=rep_aafi6b37avp',
    haoyouUrl: 'https://www.3839.com/a/148567.htm',
    qqUrl: 'https://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=Dw6s49A0iLjgIA39WJ0E0X_GAcevEVD2&authKey=183ehy5clamSYI7uO%2BmIulxikrifLoPgL4aXL0xMAregeTHjrqLsRZfND7rrz3s0&noverify=0&group_code=807755213',
    sinaUrl: 'https://weibo.com/u/7801532583',
    qqText: '仙宗大掌门同僚群：807755213',
    androidYimtUrl: 'https://bamboo.zhuziplay.com/onelink/android/cn_yimt',
    iosYimtUrl: 'https://apps.apple.com/cn/app/id6446186200?pt=126143720&ct=cn_yimt&mt=8',
    androidElemUrl: 'https://bamboo.zhuziplay.com/onelink/android/cn_elem',
    androidElemInitUrl: 'bambooplay://bamboo.zhuziplay.com/applink/com.zhuziplay.xz?channel=eleme',
    iosElemUrl: 'https://apps.apple.com/cn/app/id6446186200?pt=126143720&ct=cn_elem&mt=8',
    iosElemInitUrl: 'https://bamboo.zhuziplay.com/applink/com.zhuziplay.xz/index?channel=eleme',
  },
  homeVideo: {
    pcIndexVideo: 'https://static.zhuziplay.com/office/xzdzm/pc/xzdzm-home.mp4',
    mobileIndexVideo: 'https://static.zhuziplay.com/office/xzdzm/m/xzdzm-home.mp4',
    videoUrl: window.staticUrl + 'office/assets/video/xzdzm_video.mp4',
    yimtUrl: window.staticUrl+'office/xzdzm/mp4/yimt-index.mp4',
  },
  systemBrowser: systemBrowser,
  systemOs: systemOs,
  thinkingConfig:{
    appId: "b6b93233a2364674a971ff800aea745c",
    serverUrl: "https://receiver.ta.zhuziplay.com",
    autoTrack: {
      pageShow: false, //开启页面展示事件，事件名ta_page_show
      pageHide: false, //开启页面隐藏事件，事件名ta_page_hide
    }
  }
}

const getters = {
  thinkingConfig: state => state.thinkingConfig,
  systemOs: state => state.systemOs,
  systemBrowser: state => state.systemBrowser,
  homeVideo: state => state.homeVideo,
  utmSource: state => state.utmSource,
  adPosition: state => state.adPosition,
  downloadUrl: (state) => {
    if (source !== '') {
      state.downloadUrl.androidUrl = state.downloadUrl.androidUrl.replace('cn_zhuzi', source)
      state.downloadUrl.iosUrl = 'https://apps.apple.com/cn/app/id6446186200?pt=126143720&ct=' + source + '&mt=8'
    }
    if (position !== '') {
      state.downloadUrl.androidUrl = state.downloadUrl.androidUrl + '/' + position
    }
    return state.downloadUrl
  },
  gameNewId: state => state.gameNewId,
  homeNewId: state => state.homeNewId,
  homeBannerPid: state => state.homeBannerPid,
  mHomeBannerPid: state => state.mHomeBannerPid,
  homeGameimgPid: state => state.homeGameimgPid,
  mHomeGameimgPid: state => state.mHomeGameimgPid,
  isMobile: state => state.isMobile,
  isIPhone: state => state.isIPhone,
  staticUrl: state => state.staticUrl,
  basicData: (state) => {
    if (state.basicData.copyright === '') {
      let basicData = storage.get('basicData')
      if (basicData !== null) {
        state.basicData = JSON.parse(basicData)
      }
    }
    return state.basicData
  },
  footLinks: state => state.footLinks,
  gameUserInfo: (state) => {
    if (state.gameUserInfo.open_id === '') {
      let gameUserInfo = storage.get('gameUserInfo')
      if (gameUserInfo !== null) {
        state.gameUserInfo = JSON.parse(gameUserInfo)
      }
    }
    return state.gameUserInfo
  }
}

const mutations = {
  updateBasicData (state, params) {
    storage.set('basicData', JSON.stringify(state.basicData))
  },
  updateGameUserInfo (state, params) {
    // Object.assign(state.gameUserInfo, params)
    storage.set('gameUserInfo', JSON.stringify(state.gameUserInfo))
  },
}

const actions = {
  getSiteDetail ({ commit }, params) {
    return new Promise((resolve, reject) => {
      service.get('/siteConfig/get?id=' + window.siteConfigId, {}).then((res) => {
        if (res.data.code === 0) {
          var basicData = {
            address: res.data.data.address,
            company: res.data.data.company,
            copyright: res.data.data.copyright,
            description: res.data.data.description,
            keywords: res.data.data.keywords,
            record_number: res.data.data.record_number,
            title: res.data.data.title,
          }
          state.basicData = basicData
          commit('updateBasicData', basicData)
          resolve(res.data.data)
        } else {
          reject(res.data.msg)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  getNewsDetail ({ commit }, params) {
    return new Promise((resolve, reject) => {
      service.get('/information/get?id=' + params.id, {}).then((res) => {
        if (res.data.code === 0) {
          resolve(res.data.data)
        } else {
          reject(res.data.msg)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  getNewsList ({ commit }, params) {
    return new Promise((resolve, reject) => {
      service.get('/information/list?status=1&type=5&pageSize=' + params.pageSize + '&pageNo=' + params.pageNo, {}).then((res) => {
        if (res.data.code === 0) {
          resolve(res.data.data)
        } else {
          reject(res.data.msg)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  getBannerList ({ commit }, params) {
    return new Promise((resolve, reject) => {
      service.get('/banner/list?status=1&position_id=' + params.position_id, {}).then((res) => {
        if (res.data.code === 0) {
          resolve(res.data.data)
        } else {
          reject(res.data.msg)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  EmailLogin ({ commit }, params) {
    return new Promise((resolve, reject) => {
      service.post('/email/login', { act: true, email: params.email }).then((res) => {
        if (res.data.code === 0) {
          resolve(res.data.data)
        } else {
          reject(res.data.msg)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  ZhuziUserLogin ({ commit }, params) {
    return new Promise((resolve, reject) => {
      service.post('/login/email', { act: true, email: params.email, code: params.code }).then((res) => {
        if (res.data.code === 0) {
          resolve(res.data.data)
        } else {
          reject(res.data.msg)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  BambooSdkLogin ({ commit }, params) {
    return new Promise((resolve, reject) => {
      service.post('/login', { bamboo: true, data: { uid: params.user_id, token: params.token } }).then((res) => {
        if (res.data.code === 0) {
          var gameUserInfo = {
            channel_user_id: parseInt(res.data.data.channel_user_id),
            username: params.username,
            realname: params.realname,
            mobile: params.mobile,
            open_id: res.data.data.open_id,
            token: res.data.data.token,
            user_id: res.data.data.user_id,
            zhuziToken: params.token
          }
          state.gameUserInfo = gameUserInfo
          commit('updateGameUserInfo', gameUserInfo)
          resolve(res.data.data)
        } else {
          reject(res.data.msg)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  UserOut ({ commit }, params) {
    state.gameUserInfo = params
    commit('updateGameUserInfo', params)
  },
  GetWxmpUrlscheme ({ commit }, params) {
    return new Promise((resolve, reject) => {
      service.post('/wxmp/urlscheme/1033', { wxapp: true, query: params.query }).then((res) => {
        if (res.data.code === 0) {
          resolve(res.data.data)
        } else {
          reject(res.data.msg)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  GetIpInfo ({ commit }, params) {
    return new Promise((resolve, reject) => {
      service.post('/ip/info', { wxapp: true }).then((res) => {
        if (res.data.code === 0) {
          resolve(res.data.data)
        } else {
          reject(res.data.msg)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}
